"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAffordabilityByIncomeOutput = exports.getAffordabilityOutput = exports.getEligibleScheme = void 0;
var MortgageError_1 = require("../states/MortgageError");
var getInsuranceRate_1 = require("./getInsuranceRate");
var getMortgageOutputs_1 = require("./getMortgageOutputs");
var MortgageHandler_1 = require("./MortgageHandler");
var getMaximumPropertyValue = function (propertyValue, downPayment, tenor, mortgagePlanList, mortgageLimitTable, adValoremStampDuty) {
    var insuranceResult = getInsuranceRate_1.compareInsuranceRate(propertyValue, downPayment, tenor, mortgagePlanList, mortgageLimitTable, adValoremStampDuty);
    if (insuranceResult.error) {
        if (insuranceResult.error.type === MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_PERCENT_AMOUNT) {
            return getMaximumPropertyValue(downPayment / ((100 - insuranceResult.error.maxLoanPercent) / 100), downPayment, tenor, mortgagePlanList, mortgageLimitTable, adValoremStampDuty);
        }
        if (insuranceResult.error.type === MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_FIX_AMOUNT) {
            return getMaximumPropertyValue(downPayment + insuranceResult.error.maxLoanAmount, downPayment, tenor, mortgagePlanList, mortgageLimitTable, adValoremStampDuty);
        }
    }
    return propertyValue;
};
exports.getEligibleScheme = function (downPayment, loan, mortgageLimitTable, firstTime) {
    var eligibleTable = firstTime ? mortgageLimitTable : mortgageLimitTable.filter(function (it) { return it.firstTime === false; });
    var schemes = eligibleTable.map(function (it) {
        var newPropertyValue = Math.ceil(downPayment / ((100 - it.maxLoanPercent) / 100));
        if (newPropertyValue >= it.propertyValueMin && newPropertyValue <= it.propertyValueMax) {
            var newLoan = newPropertyValue - downPayment;
            if (it.maxLoanAmount && it.maxLoanAmount < newLoan) {
                return { value: Math.ceil(it.maxLoanAmount + downPayment), loan: Math.ceil(it.maxLoanAmount) };
            }
            return { value: newPropertyValue, loan: newPropertyValue - downPayment };
        }
        if (newPropertyValue > it.propertyValueMax) {
            if (it.maxLoanAmount) {
                if (it.maxLoanAmount + downPayment < it.propertyValueMax) {
                    return { value: Math.ceil(it.maxLoanAmount + downPayment), loan: Math.ceil(it.maxLoanAmount) };
                }
                return { value: Math.ceil(it.propertyValueMax), loan: Math.ceil(it.maxLoanAmount) };
            }
            return { value: Math.ceil(it.propertyValueMax), loan: Math.ceil(it.propertyValueMax - downPayment) };
        }
        return { value: 0, loan: 0 };
    });
    var maxScheme = schemes.reduce(function (scheme, it) {
        return it.value > scheme.value ? it : scheme;
    }, { value: 0, loan: 0 });
    if (loan < maxScheme.loan) {
        return {
            loan: loan,
            value: Math.ceil(loan + downPayment)
        };
    }
    return maxScheme;
};
exports.getAffordabilityOutput = function (affordInput) {
    var monthlyPayment = affordInput.monthlyPayment, interestRate = affordInput.interestRate, tenor = affordInput.tenor, downPayment = affordInput.downPayment, mortgageLimitTable = affordInput.mortgageLimitTable, adValoremStampDuty = affordInput.adValoremStampDuty, legalAmount = affordInput.legalAmount;
    var loan = Math.ceil(MortgageHandler_1.amortizeInverse(monthlyPayment, interestRate / 12 / 100, tenor * 12));
    var eligibleScheme = exports.getEligibleScheme(downPayment, loan, mortgageLimitTable, !adValoremStampDuty);
    var finalPropertyValue = Math.ceil(eligibleScheme.value);
    var loanAmount = Math.ceil(eligibleScheme.loan);
    var loanPercent = Math.ceil((loanAmount / finalPropertyValue) * 100);
    var assumedInterestRate = interestRate;
    var isInsuranceMonthlyRepay = false;
    var mortgageOutput = getMortgageOutputs_1.getMortgageOutputs(__assign(__assign({}, affordInput), { isInsuranceMonthlyRepay: isInsuranceMonthlyRepay, propertyValue: finalPropertyValue }));
    var totalExpenses = mortgageOutput.totalExpenses, totalCashOutlay = mortgageOutput.totalCashOutlay, totalInterest = mortgageOutput.totalInterest, totalTax = mortgageOutput.totalTax, commission = mortgageOutput.commission, schedule = mortgageOutput.schedule, insurance = mortgageOutput.insurance, insuranceInitial = mortgageOutput.insuranceInitial, rateTable = mortgageOutput.rateTable, error = mortgageOutput.error;
    return {
        isInsuranceMonthlyRepay: isInsuranceMonthlyRepay,
        insuranceInitial: insuranceInitial,
        legalAmount: legalAmount,
        propertyValue: finalPropertyValue,
        downPayment: downPayment,
        assumedInterestRate: assumedInterestRate,
        loanPercent: loanPercent,
        loanAmount: loanAmount,
        monthlyPayment: monthlyPayment,
        totalExpenses: totalExpenses,
        totalCashOutlay: totalCashOutlay,
        totalInterest: totalInterest,
        totalTax: totalTax,
        commission: commission,
        schedule: schedule,
        rateTable: rateTable,
        insurance: insurance,
        error: error
    };
};
exports.getAffordabilityByIncomeOutput = function (affordByIncomeInput) {
    var monthlyPayment = affordByIncomeInput.monthlyIncome * affordByIncomeInput.debtServiceRatio;
    var stressedInterestRate = affordByIncomeInput.interestRate + affordByIncomeInput.stressTestIncreasePercent;
    // const affordInput: MortgageAffordInput = { ...affordByIncomeInput, monthlyPayment, interestRate: stressedInterestRate };
    var affordInput = __assign(__assign({}, affordByIncomeInput), { monthlyPayment: monthlyPayment });
    var affordOutput = exports.getAffordabilityOutput(affordInput);
    var isInsuranceMonthlyRepay = false;
    var mortgageOutput = getMortgageOutputs_1.getMortgageOutputs(__assign(__assign({}, affordInput), { isInsuranceMonthlyRepay: isInsuranceMonthlyRepay, propertyValue: affordOutput.propertyValue, interestRate: affordByIncomeInput.interestRate }));
    var error = mortgageOutput.error;
    if (mortgageOutput.monthlyPayment / affordByIncomeInput.monthlyIncome > 0.5)
        error = {
            type: MortgageError_1.MortgageErrorType.EXCEED_INCOME_HALF
        };
    return __assign(__assign({}, mortgageOutput), { error: error,
        isInsuranceMonthlyRepay: isInsuranceMonthlyRepay, assumedInterestRate: stressedInterestRate, loanAmount: affordOutput.loanAmount, loanPercent: affordOutput.loanPercent, downPayment: affordByIncomeInput.downPayment, propertyValue: affordOutput.propertyValue });
};
